export function visitHeatMapRowLabel(row: {fullName: string, company?: string}): string {
    return row.company ? `${row.company}: ${row.fullName}` : row.fullName;
}

export function visitHeatMapPercentLabel(percent: number): string {
    return Number.isNaN(percent) ? '—' : `${percent}%`;
}
